module.exports = __webpack_public_path__ + "img/IntegracionLogERP_hover.e4ea356f.svg";